/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterArticlePastSearchPaid
 */
export interface RegisterArticlePastSearchPaid {
    /**
     * 自動更新するかどうか
     * @type {boolean}
     * @memberof RegisterArticlePastSearchPaid
     */
    isAutoRenewed: boolean;
}

export function RegisterArticlePastSearchPaidFromJSON(json: any): RegisterArticlePastSearchPaid {
    return RegisterArticlePastSearchPaidFromJSONTyped(json, false);
}

export function RegisterArticlePastSearchPaidFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterArticlePastSearchPaid {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAutoRenewed': json['is_auto_renewed'],
    };
}

export function RegisterArticlePastSearchPaidToJSON(value?: RegisterArticlePastSearchPaid | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_auto_renewed': value.isAutoRenewed,
    };
}

